import { Box, Divider } from '@mui/material';

import { DropdownTypography } from '#entities';
import { ICONS, ORGAN_COLORS } from '#shared';

import { searchbarClasses } from './Searchbar.styled';

import type { SearchResult } from '../../../slices';

interface SearchResultsProps {
  handleSelect: (val: string) => void;
  results: SearchResult[];
}

export const SearchResults = ({
  results,
  handleSelect,
}: SearchResultsProps) => (
  <Box className={searchbarClasses.dropdown}>
    {results.map((r, i) => {
      const color = r.organ ? ORGAN_COLORS[r.organ] : 'white';
      const OrganIcon = r.organ ? ICONS[r.organ] : null;
      const { details } = r;

      return (
        <Box
          key={i}
          className={searchbarClasses.result}
          onMouseDown={() => handleSelect(r.label)}
        >
          {/* Row 1: label + organ icon (always) */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <DropdownTypography
              className={searchbarClasses.resultLabel}
              sx={{ color }}
            >
              {r.label}
            </DropdownTypography>
            {OrganIcon && (
              <Box ml={0.5} display="flex" alignItems="center">
                <OrganIcon style={{ color, width: 18, height: 18 }} />
              </Box>
            )}
          </Box>

          {/* Matched rows only */}
          {details.flightIds?.length ? (
            <Box
              display="flex"
              alignItems="center"
              gap={0.5}
              className={searchbarClasses.resultSecondary}
              sx={{ color }}
            >
              <ICONS.airMao
                width={18}
                height={18}
                preserveAspectRatio="xMidYMid meet"
              />
              <Box
                component="span"
                sx={{
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {details.flightIds.join(', ')}
              </Box>
            </Box>
          ) : null}

          {details.rows?.map((row, idx) => {
            const Icon = row.iconKey ? ICONS[row.iconKey] : null;
            return (
              <Box
                key={`row-${idx}`}
                display="flex"
                alignItems="center"
                gap={0.5}
                className={searchbarClasses.resultSecondary}
                sx={{ color }}
              >
                {Icon && (
                  <Icon
                    width={14}
                    height={14}
                    preserveAspectRatio="xMidYMid meet"
                  />
                )}
                <Box
                  component="span"
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {row.text}
                </Box>
              </Box>
            );
          })}
          {i < results.length - 1 && (
            <Divider sx={{ my: 0.5, borderColor: 'rgba(255,255,255,0.1)' }} />
          )}
        </Box>
      );
    })}
  </Box>
);
